import type { HTMLAttributes } from 'react';
import { cn } from '../lib/cn';

type Tone = 'primary' | 'veg' | 'nonveg' | 'success' | 'warning' | 'danger' | 'info' | 'neutral';

const tones: Record<Tone, string> = {
  primary: 'bg-primary text-primary-foreground',
  veg: 'bg-veg-light text-veg',
  nonveg: 'bg-nonveg-light text-nonveg',
  success: 'bg-success-light text-success',
  warning: 'bg-warning-light text-warning',
  danger: 'bg-danger-light text-danger',
  info: 'bg-info-light text-info',
  neutral: 'bg-surface-card-hover text-content-secondary'
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
}

export function Badge({ tone = 'neutral', className, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-2 py-0.5 font-display text-[10px] font-extrabold',
        tones[tone],
        className
      )}
      {...props}
    />
  );
}
